import { useTranslation } from "react-i18next";

export default function Hero() {
  const { t } = useTranslation("slotenmaker-eindhoven");

  return (
    <section className="relative w-full overflow-hidden bg-brand-text">
      <div className="absolute inset-0 opacity-20">
        <img
          src="/img/65-professional-locksmith-working-residential.jpg"
          alt="Slotenmaker aan het werk in Eindhoven"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-brand-text/50 via-brand-text/40 to-brand-text/60" />

      <div className="relative z-10 max-w-[1440px] mx-auto px-4 md:px-10 py-20 md:py-28 lg:py-32 text-center">
        <span className="inline-block font-geist-mono text-xs md:text-sm font-bold bg-red-600 text-white px-4 py-1.5 rounded-full tracking-wider mb-6">
          {t("hero.badge")}
        </span>

        <h1 className="font-geist font-bold text-3xl md:text-5xl lg:text-[56px] text-white leading-tight tracking-tight max-w-[900px] mx-auto mb-6">
          {t("hero.h1")}
        </h1>

        <p className="font-geist text-base md:text-lg lg:text-xl text-white/80 max-w-[750px] mx-auto mb-8 md:mb-10">
          {t("hero.subtitle")}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10 md:mb-12">
          <a
            href="tel:+31638272035"
            className="inline-flex items-center gap-2 font-geist font-bold text-base md:text-lg bg-brand-yellow text-brand-text px-8 md:px-10 py-4 md:py-5 rounded-full hover:bg-white transition-colors whitespace-nowrap"
            aria-label="Bel slotenmaker Eindhoven 24/7"
          >
            <i className="ri-phone-line w-5 h-5 flex items-center justify-center"></i>
            {t("hero.ctaCall")}
          </a>
          <a
            href="#offerte"
            className="inline-flex items-center gap-2 font-geist font-semibold text-sm md:text-base text-white border border-white/40 px-6 md:px-8 py-3.5 md:py-4 rounded-full hover:bg-white/10 transition-colors whitespace-nowrap"
          >
            <i className="ri-message-3-line w-5 h-5 flex items-center justify-center"></i>
            {t("hero.ctaForm")}
          </a>
        </div>
        <p className="font-geist text-sm text-white/70 mt-2">
          Kantoor: <a href="tel:+31407987470" className="underline hover:text-white">040 798 7470</a>
          <span className="block mt-1 text-white/50 text-xs">06-nummer 24/7 bereikbaar voor spoed</span>
        </p>

        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
          <span className="flex items-center gap-2 font-geist text-sm text-white/90">
            <i className="ri-time-line w-4 h-4 flex items-center justify-center text-brand-yellow"></i>
            {t("hero.usp1")}
          </span>
          <span className="flex items-center gap-2 font-geist text-sm text-white/90">
            <i className="ri-shield-check-line w-4 h-4 flex items-center justify-center text-brand-yellow"></i>
            {t("hero.usp2")}
          </span>
          <span className="flex items-center gap-2 font-geist text-sm text-white/90">
            <i className="ri-award-line w-4 h-4 flex items-center justify-center text-brand-yellow"></i>
            {t("hero.usp3")}
          </span>
        </div>
      </div>
    </section>
  );
}